// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1e8aZ","cell":"ColumnAccessor_cell__3S-Pv","firstCellAccent":"ColumnAccessor_firstCellAccent__ndUeL"};